import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { OrderProductShortTermRentalJoinService } from '../order-products-short-term-rental-join.service';
import { OrderProductShortTermRentalJoin } from '../order-products-short-term-rental-join';
import { PropertyService } from '@app/_components/property/property.service';
import { OrderProductService } from '@app/_components/order-product/order-product.service';

@Component({
    selector: 'app-order-products-short-term-rental-join',
    templateUrl: './order-products-short-term-rental-join.component.html',
    styleUrls: ['./order-products-short-term-rental-join.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class OrderProductShortTermRentalJoinComponent implements OnInit {
	chargeTypes: any;
	feeTypes: any;
	orderProductId: any;
	shortTermRentalId: any;
	properties: any[]=[];
	orderProducts: any[]=[];
	feeFrequencies: any;
	orderProductShortTermRentalFlag = false;
	applyStaysOfNtsList: any[]=[];
	// Date: 2026-04-09 Author: Alkesh PCT applied-to options
	valuePCTAppliedToOptions: any[] = [];

	constructor(
		private primengConfig: PrimeNGConfig,
		private orderProductShortTermRentalJoinService: OrderProductShortTermRentalJoinService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		private orderProductService: OrderProductService,
		private propertyService: PropertyService,
		@Inject(MAT_DIALOG_DATA) data: any) {
			this.formTitle = data.title,
			this.orderProductId = data?.orderProductId,
			this.shortTermRentalId = data?.shortTermRentalId,
			this.orderProductShortTermRentalFlag = data?.orderProductShortTermRentalFlag;
			this.orderProductShortTermRentalJoin = data.orderProductShortTermRentalJoin,
			this.statuses = orderProductShortTermRentalJoinService.statuses;
			this.chargeTypes = orderProductShortTermRentalJoinService.chargeTypes;
			this.feeTypes = orderProductShortTermRentalJoinService.feeTypes;
			this.feeFrequencies = orderProductShortTermRentalJoinService.feeFrequencies;
			this.applyStaysOfNtsList = orderProductService.applyStaysOfNtsList;
			this.valuePCTAppliedToOptions = orderProductShortTermRentalJoinService.valuePCTAppliedToOptions;
	}

	@Input() orderProductShortTermRentalJoin: OrderProductShortTermRentalJoin;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	orderProductShortTermRentalJoinId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		orderProductId: [{ type: 'required', message: 'Required' }],
		shortTermRentalId: [{ type: 'required', message: 'Required' }],
		valueAMT: [],
		valuePCT: [],
		feeType: [],
		// active: [],
		addToRate: [],
		opsNotes: [],
		feeFrequency: [],
		useBookingRule: [],
		applyStaysOfAtLeastNts: [],
		applyStaysOfLessThanNts: [],
		showToCustomer: [],
		valuePCTAppliedTo: [],
		isAddPCTIntoLOS: []
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();
		this.fetchProperties();
		this.fetchOrderProducts();

		// if we were passed the whole orderProductShortTermRentalJoin object
		if (this.orderProductShortTermRentalJoin) {
			this.orderProductShortTermRentalJoinId = this.orderProductShortTermRentalJoin.orderProductShortTermRentalJoinId;
			this.fixDates();
			this.form1.patchValue(this.orderProductShortTermRentalJoin);
		}
	}

	fetchOrderProducts() {
		try {
			this.orderProductService.findAllOrderProducts()
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.orderProducts = res.data.orderProducts;
						return this.orderProducts;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
}

	fetchProperties() {
		try {
			this.propertyService.propertySummaryForShortData()
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.properties = res.data.properties;
						
						return this.properties;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.orderProductShortTermRentalJoinId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.orderProductShortTermRentalJoinService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.orderProductShortTermRentalJoin = res.data.orderProductShortTermRentalJoin;
						this.doAdd.emit(this.orderProductShortTermRentalJoin);
					},
					(err: any) => {
						console.log('orderProductShortTermRentalJoin-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('orderProductShortTermRentalJoin: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.orderProductShortTermRentalJoinService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.orderProductShortTermRentalJoin = res.data.orderProductShortTermRentalJoin;
						this.doUpdate.emit(this.orderProductShortTermRentalJoin);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.orderProductShortTermRentalJoinService.deleteOrderProductShortTermRentalRelationship(this.orderProductShortTermRentalJoin.orderProductId, this.orderProductShortTermRentalJoin.shortTermRentalId)
				.subscribe(
					(res: any) => {
						console.log('orderProductShortTermRentalJoin-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.orderProductShortTermRentalJoin);
					},
					(err: any) => {
						console.log('orderProductShortTermRentalJoin-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			orderProductId: [this.orderProductId, Validators.required],
			shortTermRentalId: [this.shortTermRentalId, Validators.required],
			valueAMT: [],
			valuePCT: [],
			feeType: [],
			// active: [],
			addToRate: [],
			opsNotes: [],
			feeFrequency: [],
			useBookingRule: [],
			applyStaysOfAtLeastNts: [],
			applyStaysOfLessThanNts: [],
			showToCustomer: [],
			valuePCTAppliedTo: [1],    // default: Invoice Grand Total
			isAddPCTIntoLOS: [false]   // default: false
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.orderProductShortTermRentalJoin.orderProductShortTermRentalJoinDate = moment(this.orderProductShortTermRentalJoin.orderProductShortTermRentalJoinDate).toDate();
	}

	increasePercentage(percentagefield) {
		let updatedValue = this.form1.value[percentagefield] + 0.01;
		this.form1.controls[percentagefield].setValue(updatedValue);
	}
	decreasePercentage(percentagefield){
		let updatedValue = this.form1.value[percentagefield] - 0.01;
		this.form1.controls[percentagefield].setValue(updatedValue);
	}
}
